import { render, staticRenderFns } from "./PinnedList.vue?vue&type=template&id=1070d2e5&scoped=true"
import script from "./PinnedList.vue?vue&type=script&lang=js"
export * from "./PinnedList.vue?vue&type=script&lang=js"
import style0 from "./PinnedList.vue?vue&type=style&index=0&id=1070d2e5&prod&lang=scss&scoped=true"
import style1 from "./PinnedList.vue?vue&type=style&index=1&id=1070d2e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1070d2e5",
  null
  
)

export default component.exports